import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
import(/* webpackMode: "eager" */ "/app/src/app/GoogleAdsConversion.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/hyphenology.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/providers.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/CookieConsent/component.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/ScrollbarHelper.tsx")